import React from 'react';
import { Clock, Globe } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8 xl:col-span-1">
            <div className="flex items-center text-white">
              <img src="/logo-ares.png" alt="ARES Logo" className="h-10 w-auto mr-2" />
              <span className="text-xl font-bold tracking-tight">ARES GLOBAL CONTROL</span>
            </div>
            <p className="text-blue-100 text-base">
              Excelencia, confianza y profesionalidad en cada detalle.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center text-blue-100 text-sm">
                <Globe className="h-5 w-5 mr-3 text-blue-400" />
                <span>Cobertura en toda la Comunidad Valenciana y territorio nacional.</span>
              </div>
              <div className="flex items-center text-blue-100 text-sm">
                <Clock className="h-5 w-5 mr-3 text-blue-400" />
                <span>Atención y respuesta operativa 24/7.</span>
              </div>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-blue-300 tracking-wider uppercase">Servicios</h3>
                <ul className="mt-4 space-y-4">
                  <li><a href="#servicios" className="text-base text-blue-100 hover:text-white transition-colors">Gestión de Accesos</a></li>
                  <li><a href="#servicios" className="text-base text-blue-100 hover:text-white transition-colors">Mantenimiento y Limpieza</a></li>
                  <li><a href="#servicios" className="text-base text-blue-100 hover:text-white transition-colors">Auxiliares Especializados</a></li>
                  <li><a href="#servicios" className="text-base text-blue-100 hover:text-white transition-colors">Conserjería</a></li>
                  <li><a href="#servicios" className="text-base text-blue-100 hover:text-white transition-colors">Protocolo y Admisión</a></li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-blue-300 tracking-wider uppercase">Empresa</h3>
                <ul className="mt-4 space-y-4">
                  <li><a href="#inicio" className="text-base text-blue-100 hover:text-white transition-colors">Inicio</a></li>
                  <li><a href="#valores" className="text-base text-blue-100 hover:text-white transition-colors">Valores</a></li>
                  <li><a href="#contacto" className="text-base text-blue-100 hover:text-white transition-colors">Contacto</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-blue-800 pt-8">
          <p className="text-base text-blue-200 xl:text-center">
            &copy; {new Date().getFullYear()} Ares Global Control. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
